// src/components/Views/FormulaireInscription.js
import React, { useState } from "react";
import Button from "./UI/Button";
import Input from "./UI/Input";

/**
 * FormulaireInscription
 * - Protège contre onRegisterSuccess undefined (évite "n is not a function")
 */
const FormulaireInscription = ({ onRegisterSuccess, t = {}, onToggleMode }) => {
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    password: "",
    telephone: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e?.target || {};
    if (!name) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // ✅ Protection principale : évite le crash
    if (typeof onRegisterSuccess !== "function") {
      setError(
        "Erreur interne: la fonction d'inscription n'est pas disponible (onRegisterSuccess)."
      );
      return;
    }

    setLoading(true);
    try {
      await onRegisterSuccess(formData);
      // Optionnel: tu peux basculer en mode login après succès
      // onToggleMode?.();
      console.log("✅ Inscription OK:", formData.email);
    } catch (err) {
      setError(
        err?.message || "Une erreur est survenue lors de l'inscription."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-form-container page-transition">
      <div className="auth-header">
        <h2>{t.createAccount || "Créer un compte"}</h2>
        <p className="auth-subtitle">
          {t.joinUs || "Rejoignez l'excellence du Marché de Luxe"}
        </p>
      </div>

      <form onSubmit={handleSubmit} className="auth-form-luxury">
        <div className="form-row">
          <Input
            label={t.firstName || "Prénom"}
            name="prenom"
            value={formData.prenom}
            onChange={handleChange}
            placeholder="Jean"
            required
          />
          <Input
            label={t.lastName || "Nom"}
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            placeholder="Dupont"
            required
          />
        </div>

        <Input
          label={t.email || "Email"}
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="jean.dupont@exemple.com"
          required
        />

        <Input
          label={t.password || "Mot de passe"}
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="••••••••"
          required
        />

        <Input
          label={t.phone || "Téléphone"}
          type="tel"
          name="telephone"
          value={formData.telephone}
          onChange={handleChange}
          placeholder="+41 79 000 00 00"
        />

        {error && <div className="auth-error-message">{error}</div>}

        <div className="auth-actions">
          <Button type="submit" variant="gold" disabled={loading} fullWidth>
            {loading
              ? t.processing || "Traitement..."
              : t.registerAction || "S'INSCRIRE"}
          </Button>
        </div>
      </form>

      <div className="auth-footer">
        <span>{t.alreadyMember || "Déjà membre ?"}</span>
        <button
          type="button"
          onClick={() => onToggleMode?.()}
          className="auth-link-btn"
        >
          {t.loginAction || "Se connecter"}
        </button>
      </div>

      {/* ⚠️ CRA n'aime pas toujours "style jsx". Si tu as un warning, remplace par <style> */}
      <style>{`
        .auth-form-luxury {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          margin-top: 2rem;
        }
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        .auth-header {
          text-align: center;
          margin-bottom: 2rem;
        }
        .auth-subtitle {
          color: var(--text-muted);
          font-style: italic;
        }
        .auth-error-message {
          color: #ff4d4f;
          background: rgba(255, 77, 79, 0.1);
          padding: 0.8rem;
          border-radius: 4px;
          font-size: 0.9rem;
          text-align: center;
        }
        .auth-footer {
          margin-top: 2rem;
          text-align: center;
          font-size: 0.9rem;
        }
        .auth-link-btn {
          background: none;
          border: none;
          color: var(--gold);
          text-decoration: underline;
          cursor: pointer;
          margin-left: 0.5rem;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default FormulaireInscription;
